module.exports = __webpack_public_path__ + "static/media/designPatent_30-1018451.c0fe9143.png";